const ContactEndpoint = {
  CREATE: '/default/contact/create',
  EDIT_CONTACT: '/default/contact/edit-contact',
  EDIT_BASE: '/default/contact/edit-base',
  EDIT_AUTHENTICATION: '/default/contact/edit-authentication',
  EDIT_TEAMS_SYSTEMS: '/default/contact/edit-teams-systems',
  DELETE_USER: '/default/contact/delete-user',
  DELETE_CONTACT: '/default/contact/delete-contact',
  GET: '/default/contact/get',
  GET_BASE_INFO: '/default/contact/get-base-info',
  GET_SYSTEMS_INFO: '/default/contact/get-systems-info',
  GET_TEAMS_INFO: '/default/contact/get-teams-info',
  IS_PASSWORD_COMPLIANT: '/default/contact/is-password-compliant',
  SAVE_ASSIGNMENTS: '/default/contact/save-assignments',
  SAVE_ORGANIZATION: '/default/contact/save-organization',
  SAVE_ADDRESS: '/default/contact/save-address',
  SAVE_PREFERENCES: '/default/contact/save-preferences',
};

export default ContactEndpoint;
